export default __webpack_public_path__ + "static/media/project5.52f08584.png";